var MPattern = {};

MPattern.events = {
    selectedSettingsObject: {},

    initialize: function() {
        var self = MPattern.events;
        self.bindEvents();
    },

    bindEvents: function() {
        var self = MPattern.events;
        var $patternContainer = $("div#prolook-patterns-main-container");
        $patternContainer.on('click', 'a', self.applyPattern);
    },

    showPartPatternModal: function() {
        var $patternContainer = $("div#prolook-patterns-main-container");
        var $template = $('#m-prolook-patterns').html();
        var isQuickturnSockBlockPattern = _.contains(['Quick Turn', 'Sock'], ub.config.option);
        var patterns = ub.funcs.getPatternList();

        if (isQuickturnSockBlockPattern) {
            patterns = ub.data.qtPatterns.items;
        }

        var markup = Mustache.render($template, {
            patterns: patterns,
            patternFor: "materialOptionType"
        });

        $patternContainer.html(markup);

        //hide pattern id from normal user
        if (!_.contains(ub.fontGuideIDs, ub.user.id)) {
            $('span.pattern-id').hide();
        }

        UIkit.modal("div#prolook-patterns-modal").show();
    },

    showApplicationPatternModal: function(settingsObject) {
        var self = MPattern.events;
        var $patternContainer = $("div#prolook-patterns-main-container");
        var $template = $('#m-prolook-patterns').html();
        var patterns = ub.funcs.getPatternList();
        var isQuickturnSockBlockPattern = _.contains(['Quick Turn', 'Sock'], ub.config.option);

        if (isQuickturnSockBlockPattern) {
            patterns = _.filter(patterns, function(pattern) {
                if (!_.contains(["geometric_fade", "ns", "net_fade"], pattern.code)) {
                    return pattern;
                }
            });
        }

        self.selectedSettingsObject = settingsObject;

        var markup = Mustache.render($template, {
            patterns: patterns,
            patternFor: "applicationType"
        });

        $patternContainer.html(markup);

        UIkit.modal("div#prolook-patterns-modal").show();
    },

    applyPattern: function() {
        var self = MPattern.events;
        var patternID = $(this).data('pattern-id');
        var patternFor = $(this).data("pattern-for");
        
        switch(patternFor) {
            case "materialOptionType":
                ub.funcs.changePatternFromPopup(ub.current_part, patternID);
                break;
            
            case "applicationType":
                var settingsObject = self.selectedSettingsObject;
                var matching = undefined;

                if (!_.isEmpty(settingsObject)) {
                    ub.funcs.changePatternFromPopupApplications(settingsObject, patternID);

                    matching = ub.data.matchingIDs.getMatchingID(settingsObject.code);
                    if (typeof matching !== "undefined") {
                        var _matchingSettingsObject = _.find(ub.current_material.settings.applications, {code: matching.toString()});
                        ub.funcs.changePatternFromPopupApplications(_matchingSettingsObject, patternID);
                    }

                    _.delay(function() {
                        ApplicationCore.view.renderPattern(settingsObject);
                    }, 100);

                    self.selectedSettingsObject = {};
                }
                
                break;
            default:
                console.warn("The selected pattern cannot be applied.");
        }

        UIkit.modal("div#prolook-patterns-modal").hide();
    }
};